import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { SingleCard } from "./layouts";
import { LoginForm, CreateAccountForm } from "./components";
import { ResetPassword, SetNewPassword } from "./pages";

export default function () {
  const location = useLocation();

  const saveCurrentUrl = () => {
    const url = location.pathname + location.search;
    if (
      url !== "/login" &&
      url !== "/reset-password" &&
      !url.includes("/set-new-password")
    ) {
      sessionStorage.setItem("returnTo", url);
    }

  };

  return (
    <Switch>
      <Route exact path="/login">
        <SingleCard title="Sign In">
          <LoginForm />
        </SingleCard>
      </Route>

      <Route exact path="/create-account">
        <SingleCard title="Sign Up">
          <CreateAccountForm />
        </SingleCard>
      </Route>

      <Route exact path="/reset-password">
        <ResetPassword />
      </Route>

      <Route exact path="/set-new-password">
        <SetNewPassword />
      </Route>

      {/* Your commented routes here */}

      <Route path="*">
        {saveCurrentUrl()}
        <Redirect to={"/login"} />
      </Route>
    </Switch>
  );
}
